import { checkDeviceType, emitter, EventEnum, winOpen } from '@star/utils';
import { computed } from 'vue';
import { storeToRefs, useModalStore, useTenantStore } from '@star/stores';
import { useRoute } from 'vue-router';
import { promiseTimeout, useScriptTag } from '@vueuse/core';
import { showFailToast } from 'vant';
import { ModalTypeEnum } from '@star/constants';
import { startsWith } from 'lodash-es';

type PositionType = 'top' | 'bottom';

export default function useDownloadApp(position: PositionType = 'bottom') {
  const route = useRoute();
  const { tenantInfo, isRepairing } = storeToRefs(useTenantStore());
  const modalStore = useModalStore();
  const { showTopDownload, showBottomDownload } = storeToRefs(modalStore);

  const appKey = computed(() => {
    return tenantInfo.value.sysOptions?.OPENSHARE_KEY ?? '';
  });

  const openinstallAppKey = computed(() => {
    return tenantInfo.value.sysOptions?.OPENINSTALL_APP_KEY ?? '';
  });

  // const channelCode = computed(() => {
  //   return tenantInfo.value.sysOptions?.OPENINSTALL_CHANNEL_CODE ?? '';
  // });

  const code = computed(() => {
    return route.query?.code || '';
  });

  const downloadHandle = () => {
    try {
      if (window.openShareInstance || window.OpenInstallInstance) {
        window.openShareInstance?.wakeupOrInstall?.();
        window.OpenInstallInstance?.wakeupOrInstall?.();
      } else {
        const { app_reg_addr, official_addr } = tenantInfo.value.tenant;
        const deviceType = checkDeviceType();
        if (deviceType == 'ios') {
          winOpen(app_reg_addr);
        } else if (deviceType == 'Android') {
          winOpen(official_addr);
        } else {
          showFailToast('PC端暂不支持');
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  // const { load, unload } = useScriptTag(
  //   'https://os.sdwok.cn/open/os2.js',
  //   (el: HTMLScriptElement) => {
  //     window.openShareInstance = new window.OpenShare({
  //       appKey: appKey.value,
  //       code: code.value,
  //     });
  //     console.log(window.openShareInstance, '---- window.openShareInstance ----');
  //   },
  //   { manual: true }
  // );

  const init = async (type: PositionType = 'bottom') => {
    if (!(route.name === 'home' || startsWith(location.pathname, '/home') || location.pathname === '/')) return;
    if (!isRepairing.value) {
      // if (!!appKey.value && !!code.value) {
      //   await load();
      // }
      if (type === 'bottom') {
        modalStore.addPopupModal(ModalTypeEnum.BOTTOM_DOWNLOAD_MODAL);
      }

      if (type === 'top') {
        modalStore.addPopupModal(ModalTypeEnum.TOP_DOWNLOAD_MODAL);
      }
    }
  };

  const close = async (isScroll: boolean = false) => {
    console.log(position, 'position');
    if (position === 'bottom') {
      await modalStore.hideModal(ModalTypeEnum.BOTTOM_DOWNLOAD_MODAL);
      modalStore.setModalStatus(ModalTypeEnum.BOTTOM_DOWNLOAD_MODAL, {
        forever: true,
      });
    } else {
      await modalStore.hideModal(ModalTypeEnum.TOP_DOWNLOAD_MODAL);
    }
    if (isScroll) {
      await promiseTimeout(180);
      emitter.emit(EventEnum.HOME_PAGE_SCROLL);
    }
  };

  const loadScript = async () => {
    window.openShareInstance = null;
    window.OpenInstallInstance = null;

    // openShare
    if (!!appKey.value && !!window.OpenShare) {
      // await load();
      console.log(appKey.value, code.value, 'loadScript openShare');
      window.openShareInstance = new window.OpenShare({
        appKey: appKey.value,
        code: code.value,
      });
    }

    // openinstall
    if (!!openinstallAppKey.value) {
      useScriptTag(
        `https://res.openinstall.com/openinstall-${openinstallAppKey.value}.js`,
        (el: HTMLScriptElement) => {
          const data = window.OpenInstall?.parseUrlParams();
          new window.OpenInstall(
            {
              appKey: openinstallAppKey.value,
              channelCode: code.value,
              fastInstall: false,
              onready: function () {
                window.OpenInstallInstance = this;
                console.log(openinstallAppKey.value, code.value, 'loadScript openinstall');
              },
            },
            data
          );
        },
        { manual: false }
      );
    }
  };

  return {
    showTopDownload,
    showBottomDownload,
    init,
    loadScript,
    close,
    downloadHandle,
  };
}
